import React from 'react';
import {
  TextButtonPriority as TEXT_BUTTON_PRIORITY,
  TextButton,
  Tooltip,
  TooltipSkin,
} from 'wix-ui-tpa/cssVars';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { st, classes } from './ParticipantActionButton.st.css';
import { ParticipantActionButtonDataHooks } from './dataHooks';

export interface ParticipantActionButtonProps {
  label: string;
  icon: React.ReactElement;
  onClick: () => void;
  disabled?: boolean;
  tooltipContent?: string;
  dataHook?: string;
}

const ParticipantActionButton: React.FC<ParticipantActionButtonProps> = ({
  label,
  icon,
  onClick,
  disabled,
  tooltipContent,
  dataHook,
}) => {
  const { isMobile } = useEnvironment();
  const button = (
    <TextButton
      priority={TEXT_BUTTON_PRIORITY.primary}
      className={classes.button}
      data-hook={dataHook}
      disabled={disabled}
      onClick={onClick}
      prefixIcon={icon}
    >
      {label}
    </TextButton>
  );

  return (
    <div className={st(classes.root, { isMobile })}>
      {tooltipContent ? (
        <Tooltip
          skin={TooltipSkin.Wired}
          content={tooltipContent}
          minWidth={200}
          data-hook={ParticipantActionButtonDataHooks.TOOLTIP}
        >
          {button}
        </Tooltip>
      ) : (
        button
      )}
    </div>
  );
};

export default ParticipantActionButton;
